/* PureState UTM capture: first-touch params per session, written once to cart attributes. */
if (!window.psUtm) {
  window.psUtm = (function () {
    if (window.Shopify && Shopify.designMode) return null;
    var KEY = 'ps_utm', SENT = 'ps_utm_sent', busy = false;
    var keys = (document.documentElement.dataset.psUtmKeys || '').split(',').map(function (k) { return k.trim(); }).filter(Boolean);
    function read(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
    function write(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
    function capture() {
      if (!keys.length || read(KEY)) return;
      var params = new URLSearchParams(location.search), data = {}, hit = false;
      keys.forEach(function (k) {
        var v = params.get(k);
        if (v) { data[k] = v.slice(0, 255); hit = true; }
      });
      if (!hit) return;
      data.landing_page = (location.pathname + location.search).slice(0, 255);
      data.ts = new Date().toISOString();
      write(KEY, JSON.stringify(data));
    }
    function send() {
      var raw = read(KEY), attrs;
      if (!raw || read(SENT) === '1' || busy || !window.fetch) return;
      try { attrs = JSON.parse(raw); } catch (e) { return; }
      /* ts stays in the session record only; only utm_*, click ids and landing_page go to the cart. */
      delete attrs.ts;
      busy = true;
      var body = JSON.stringify({ attributes: attrs });
      var opts = { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: body };
      var url = (window.routes && routes.cart_update_url) || '/cart/update.js';
      fetch(url, opts)
        .then(function (r) {
          /* a locale-prefixed cart route can 404 behind some proxies; retry once on the unprefixed endpoint */
          if (!r.ok && url !== '/cart/update.js') return fetch('/cart/update.js', opts);
          return r;
        })
        .then(function (r) { if (r && r.ok) write(SENT, '1'); })
        .catch(function () {})
        .then(function () { busy = false; });
    }
    capture();
    send();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      var off = subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        if (typeof off === 'function') off();
        send();
      });
    }
    return { capture: capture, send: send };
  })();
}
